import { useTranslation } from 'react-i18next';
import React, { useCallback } from 'react';
import { useMutation } from 'react-query';
import toast from 'react-hot-toast';
import { useHistory } from 'react-router-dom';

import { request, useCurrentUserId, toastError } from '@/utils';

import styles from '../index.module.scss';
import { FeedArticleDetail } from '../types';
import { setQueryAllFeedDetailByArticleId } from './setQuery';

const setBookmark = (id: number, bookmarked?: boolean, currentAddress?: string) => {
  const recipe = (pre?: FeedArticleDetail) => {
    if (pre?.article) {
      pre.article.is_bookmarked = bookmarked;
      pre.article.bookmark_count = bookmarked
        ? (pre.article.bookmark_count || 0) + 1
        : pre.article.bookmark_count > 0
          ? pre.article.bookmark_count - 1
          : 0;
    }
  };

  setQueryAllFeedDetailByArticleId({ currentAddress: currentAddress!, articleId: id, recipe });
};

export const useArticleBookmark = (article_id: number, isAdd?: boolean) => {
  const { t } = useTranslation();

  const history = useHistory();
  const currentAddress = useCurrentUserId();

  const handleBookmarkView = useCallback(() => {
    history.push(`/bookmarks`);
  }, [history]);

  return useMutation(
    () => {
      setBookmark(article_id, isAdd, currentAddress);
      return request.post<{ is_success: boolean }>(`/bookmark/${isAdd ? 'add' : 'remove'}`, {
        article_id,
      });
    },
    {
      onSuccess(res) {
        if (!res?.is_success) {
          toastError('Failed');

          setBookmark(article_id, !isAdd, currentAddress);

          return;
        } else if (!isAdd) {
          toast(<div className={styles.toast}>{t('hooks_bookmark.removed')}</div>, {
            duration: 1000,
          });
        }

        if (isAdd) {
          toast(
            <div className={styles.toast}>
              {t('hooks_bookmark.dww1g5')}
              <span onClick={handleBookmarkView} className={styles.toastView}>
                {t('hooks_bookmark.1l58l')}
              </span>
            </div>,
            { duration: 3000 },
          );
        }
      },
      onError(err: any) {
        setBookmark(article_id, !isAdd, currentAddress);
        toastError(err || 'Failed');
      },
    },
  );
};
